import { GET_FILTERS } from './action-types';
import { getRequestStatus } from '../../requests/selectors';

export const filters = (state) => state.data.filters.filters;
export const getNFilters = (state) => state.data.filters.nFilters;
export const getBFilters = (state) => state.data.filters.bFilters;
export const getfilterGroups = (state) => state.data.filters.filterGroups;
export const [isFetching, hasError, errorData] = getRequestStatus(GET_FILTERS);
